import React, {useState, useEffect} from 'react'
import styles from './index.module.scss'
import {
    useUpdateMyProfile,
    useGetMyProfile, 
} from '../../services/mutations'
import {localStorageKeys, useLocalStorage} from '../../utils/localStorageItems'
import ProfileDataDOB from '../ProfileDataDOB'
import UploadPhotos from '../UploadPhotos'
import Loader from '../../molecule/Loader'
import ProfileDataName from '../../organism/ProfileDataName'


const MyProfileUpdatProfile = ({
    QuestionID,
    identifier,
    allQuestions,
    allAnwers,
    setEditMode,
    userDetails
}) => {
    const [dob, setDob] = useState('')
    const [age, setAge] = useState(0)
    const [error, setError] = useState('')
    const [formattedDob, setFormattedDob] = useState(null)
    const updateMyProfile = useUpdateMyProfile();
    const getMyProfile = useGetMyProfile();
    const localStorageItem = useLocalStorage();
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')

    const parseUsDate = (value) => {
        const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || '');
        if (!match) return null;
        const month = Number(match[1]);
        const day = Number(match[2]);
        const year = Number(match[3]);
        const parsedDate = new Date(year, month - 1, day);
        if (
            parsedDate.getFullYear() !== year ||
            parsedDate.getMonth() !== month - 1 ||
            parsedDate.getDate() !== day
        ) {
            return null;
        }
        return parsedDate;
    }

    function calculate_age(dateOfBirth) { 
        const today = new Date();
        let calculatedAge = today.getFullYear() - dateOfBirth.getFullYear();
        const hasBirthdayPassed =
            today.getMonth() > dateOfBirth.getMonth() ||
            (today.getMonth() === dateOfBirth.getMonth() &&
                today.getDate() >= dateOfBirth.getDate());
        if (!hasBirthdayPassed) calculatedAge -= 1;
        return calculatedAge;
    }
    const onDateChange = (_date)=>{
        setDob(_date)
        const parsedDob = parseUsDate(_date);
        if (parsedDob) {
            setAge(calculate_age(parsedDob))
        }
    }
    const onSubmitClickedDOB = () =>{
        const parsedDob = parseUsDate(dob);
        if(!dob){
            setError('Please provide your date of birth.')
            return false
        }else if(!parsedDob){
            setError('Please enter your date of birth as MM/DD/YYYY.')
            return false
        }

        const calculatedAge = calculate_age(parsedDob);
        if(calculatedAge < 18){
            setError('Your age should be greater than 18.')
            return false
        }else if(calculatedAge > 95){
            setError('Your age should be less than 95.')
            return false
        }else{
            if(dob){
               
                let payloadData = {}
                payloadData.dob = dob
                updateProfile(payloadData)
            }
        }
    }
    const updateProfile = (data) => {
        console.log('updateProfile payloadData: ', data)
        setLoading(true)
        updateMyProfile.mutate(data,{
            onSuccess: response => {
                console.log('updateMyProfile onSuccess: ', response)
                setLoading(false)
                onBackClicked();
            },
            onError: err =>{
                console.log('updateMyProfile onError: ', err)
                setLoading(false)
            }
        })
    }
    const profileImagesUploadSuccess = ()=>{
        console.log('profileImagesUploadSuccess')
        onBackClicked()
    }

    const onBackClicked = ()=>{
        setEditMode(false)
    }

    const onFirstNameChange = (_name)=>{
        setFirstName(_name)
        if(_name === ''){
            setError('Please enter your First Name')
           
        }else{
            setError('')
            
        }
    }

    const onLastNameChange = (_name)=>{
        setError('')
        setLastName(_name)
    
    }
    const onNextNameClicked = ()=>{
        setError('')
        if(firstName.length === 0){
            setError('Please enter your First Name.')
        }else if(lastName.length === 0){
            setError('Please enter your Last Name.')
        }else{
            setError('')
            let payloadData = {
                user:{
                    first_name:firstName,
                    last_name:lastName
                }
            }
            // payloadData.user.first_name = firstName
            // payloadData.user.last_name = lastName
            updateProfile(payloadData)
            
            
        }
    }
    useEffect(()=>{
        if(userDetails?.dob){
            console.log('userDetails: ', userDetails)
            setDob(userDetails?.dob)
            const parsedDob = parseUsDate(userDetails?.dob);
            if (parsedDob) {
                setAge(calculate_age(parsedDob))
            }
        }

        if(userDetails?.user){
            setFirstName(userDetails?.user?.first_name)
            setLastName(userDetails?.user?.last_name)
        }
    },[])

    return ( 
        <>
        <Loader open={loading}/>
            {identifier==='age' && (
                <ProfileDataDOB
                dob={dob}
                onDateChange={onDateChange}
                onNextClicked={onSubmitClickedDOB}
                error={error}
                onBackClicked={onBackClicked}
                age={age}
                submitBtnText={'Save'}
                />
            )}
            {identifier==='photos' && (
                <UploadPhotos
                    setShowLoading={setLoading}
                    onBackClicked={onBackClicked}
                    btnSubmitText={'Save'}
                    onUploadSuccess={profileImagesUploadSuccess}
                    showbackButton={true}
                    
                />
            )}
            {identifier==='name' && (
                <ProfileDataName
                first_name={firstName}
                last_name={lastName}
                onFirstNameChange={onFirstNameChange}
                onLastNameChange={onLastNameChange}
                onNextClicked={onNextNameClicked}
                error={error}
                onBackClicked={onBackClicked}
                submitBtnText={'Save'}
                showAppIcon={false}
                />
            )}
        </>
     );
}
 
export default MyProfileUpdatProfile;
